import { getTenantSlugFromHostname } from './tenantDetection';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
export const TENANT_SLUG = getTenantSlugFromHostname();
export const CENTRAL_POSTAL_CODE = process.env.REACT_APP_CENTRAL_POSTAL_CODE || 'V5Y 3T8';

// Tenant-specific themes
const tenantThemes: Record<string, { name: string; colors: typeof sharewaresColors; logo: string }> = {
  'sharewares': {
    name: 'ShareWares',
    colors: {
      primary: '#ff0090',
      secondary: '#ff99cc',
      accent: '#e60080',
      background: '#fafafa',
      text: '#333',
      white: '#ffffff'
    },
    logo: '/sw-logo-pink-rgb-512.png'
  },
  'alphaselect': {
    name: 'Alpha Select',
    colors: {
      primary: '#00E676',
      secondary: '#7C3AED',
      accent: '#00C853',
      background: '#fafafa',
      text: '#333',
      white: '#ffffff'
    },
    logo: '/alphaselect-logo.png'
  }
};

// Default ShareWares colors (used as fallback)
const sharewaresColors = {
  primary: '#ff0090',
  secondary: '#ff99cc',
  accent: '#e60080',
  background: '#fafafa',
  text: '#333',
  white: '#ffffff'
};

// Get current tenant theme
const currentTenant = tenantThemes[TENANT_SLUG] || tenantThemes['sharewares'];
export const TENANT_NAME = process.env.REACT_APP_TENANT_NAME || currentTenant.name;
export const TENANT_LOGO = currentTenant.logo;
export const colors = currentTenant.colors;

// ShareWares Customer Agreement
export const CONTRACT_TEXT = `**SHAREWARES CUSTOMER AGREEMENT**

This Agreement sets out the terms between ShareWares (the "Company") and the customer ("Customer") placing an order for reusable wares. By placing an order and checking the box to accept this Agreement, the Customer agrees to the following:

**1. Service Fees, Deposits, and Taxes**

• All service fees are subject to GST.
• All deposits and refunds include GST/PST.
• Deposits are used to secure the return of wares. Refunds are not available for items returned damaged.

• **Single Events:** A date-hold deposit equal to 50% of service fees is due upon order. After the event, a final invoice will include the remaining service fee balance plus a loss fee for unreturned wares (discounted from open system rates).
• **Ongoing Venues:** Monthly invoices include service fees and a rolling balance of discounted deposits and refunds for returned items. No separate loss fee is charged; unreturned wares are simply not refunded.
• **Open System Businesses:** ShareWares charges the business the deposit for each ware borrowed. The business may pass this deposit charge and refund responsibility to its consumers, who can claim refunds via the QR code. No separate loss fee is charged; the consumer simply forfeits the refund if the ware is not returned.

• Refunds or deposit offsets will appear on the next applicable invoice after pickup, washing, and restocking.
• Custom case quantities can be requested at an additional $0.05 per unit.
• A 10% discount is available for pre-orders exceeding 10,000 units.

**2. Payment Terms**

• All invoices are due within 30 calendar days of invoice date (Net 30).
• Interest may be charged on overdue balances at the maximum rate permitted by law.

**3. Bin Placement and Signage** To maximize return rates and reduce costs, the Customer agrees to:

• Provide clearly marked return bins or collection receptacles, or rent from ShareWares.
• Locate them at:

• All bars, concessions, or points of sale where reusables are distributed.
• All waste sorting stations (landfill, compost, recycling).
• All venue exits.

• ShareWares does not prescribe specific messaging on signage but requires that signage include a URL and may optionally include a pop-up image sized 600x1068 pixels for activation via QR code.

**4. Staff Engagement** Customer will take reasonable steps to engage relevant staff (e.g., bussers, hosts, event planners, security, housekeeping, bar staff) to encourage ware returns.

**5. QR Code Marketing Opportunities** QR codes may be assigned an activation, such as:

• Sponsorship promotion
• 50/50 draws
• Advertising upcoming events
• Connecting consumers with the Customer's brand or campaigns

**6. Wares**

• Wares remain the property of ShareWares at all times.
• Wares must be returned in reusable condition to be eligible for deposit refunds.
• The Customer is responsible for loss, theft, or damage while wares are in their possession.

**7. Licenses and Permits** You represent that you hold all necessary licenses, permits, and authorities to operate legally.

**8. Limitation of Liability** The Company will not be liable for any indirect, incidental, or consequential damages arising from the use of wares or services.

**9. Entire Agreement** This Agreement constitutes the entire agreement between the parties and supersedes any prior discussions or understandings.`; 
